module.exports = __webpack_public_path__ + "img/fabu.4df6f8ec.png";